import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContractGlobalService } from 'src/app/core/services';

@Injectable({
  providedIn: 'root'
})
export class EcsExternalFrontsService {

  constructor(private readonly contractGlobalService: ContractGlobalService) { }

  redirectToTrafficUrl() {
    const href = environment.webVisumTrafficUrl;
    const encoded = this.generateToken();
    window.location.href = href + '/auth/me?context=' + encoded;
  }

  private generateToken(){
    return btoa(JSON.stringify({
      accessToken: JSON.parse(localStorage.getItem('accessToken')),
      selectedContracts: this.contractGlobalService.contracts
    }));
  }
}
